/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type {
    AssetStatusSummaryResponse,
    GetAllParams,
    PagedResponseAssetResponse
} from '../models';

export type getAllResponse200 = {
    data: PagedResponseAssetResponse;
    status: 200;
};

export type getAllResponse400 = {
    data: void;
    status: 400;
};

export type getAllResponse500 = {
    data: void;
    status: 500;
};

export type getAllResponseSuccess = getAllResponse200 & {
    headers: Headers;
};

export type getAllResponseError = (getAllResponse400 | getAllResponse500) & {
    headers: Headers;
};

export type getAllResponse = getAllResponseSuccess | getAllResponseError;

export const getGetAllUrl = (params?: GetAllParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['sort'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach(v => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/api/v1/assets?${stringifiedParams}` : `/api/v1/assets`;
};

export const getAll = async (
    params?: GetAllParams,
    options?: RequestInit
): Promise<getAllResponse> => {
    const res = await fetch(getGetAllUrl(params), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getAllResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getAllResponse;
};

export type getStatusSummaryResponse200 = {
    data: AssetStatusSummaryResponse;
    status: 200;
};

export type getStatusSummaryResponse400 = {
    data: void;
    status: 400;
};

export type getStatusSummaryResponse500 = {
    data: void;
    status: 500;
};

export type getStatusSummaryResponseSuccess = getStatusSummaryResponse200 & {
    headers: Headers;
};

export type getStatusSummaryResponseError = (
    | getStatusSummaryResponse400
    | getStatusSummaryResponse500
) & {
    headers: Headers;
};

export type getStatusSummaryResponse =
    | getStatusSummaryResponseSuccess
    | getStatusSummaryResponseError;

export const getGetStatusSummaryUrl = () => `/api/v1/assets/summary`;

export const getStatusSummary = async (
    options?: RequestInit
): Promise<getStatusSummaryResponse> => {
    const res = await fetch(getGetStatusSummaryUrl(), {
        ...options,
        method: 'GET'
    });

    const contentType = (res.headers.get('content-type') ?? '').toLowerCase();
    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data: getStatusSummaryResponse['data'] = body
        ? contentType.includes('json')
            ? JSON.parse(body)
            : body
        : {};

    return { data, headers: res.headers, status: res.status } as getStatusSummaryResponse;
};
